<template>
  <q-card :class="'bg-' + color" dark class="minicard q-pa-sm">
    <div class="row justify-between" style="height: calc(100% + 12px)">
      <div class="col">
        <div>{{ caption }}</div>
        <div class="value">{{ value }}</div>
      </div>
      <div v-if="secondaryValue !== null" class="col" style="text-align: right" :style="!secondaryHighlight ? 'opacity: 0.7' : ''">
        <div :class="secondarySize == 'small' ? 'small-value' : 'value'">
          {{ secondaryValue }}
        </div>
        <div :class="!secondaryHighlight ? 'text-caption' : ''" style="white-space: nowrap">
          {{ secondaryCaption }}
        </div>
      </div>
      <div v-if="!!icon" class="col" style="opacity: 0.8; text-align: right">
        <q-icon :name="icon" size="4rem"></q-icon>
      </div>
    </div>
  </q-card>
</template>

<script setup>
defineProps({
  color: { type: String },
  caption: { type: String },
  value: { type: String },
  secondaryCaption: { type: String },
  secondaryValue: { type: String },
  secondarySize: { type: String },
  icon: { type: String },
  secondaryHighlight: { type: Boolean },
});
</script>

<style lang="scss" scoped>
.q-card {
  .value {
    font-size: 2rem;
    line-height: 2.5rem;
    font-weight: 300;
  }
  .small-value {
    font-size: 1.5rem;
    line-height: 2.5rem;
    font-weight: 300;
  }
}
</style>
